import { render } from "./PayRollDrawer.vue?vue&type=template&id=6137e4b6&ts=true"
import script from "./PayRollDrawer.vue?vue&type=script&lang=ts"
export * from "./PayRollDrawer.vue?vue&type=script&lang=ts"

import "./PayRollDrawer.vue?vue&type=style&index=0&id=6137e4b6&lang=css"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__